<template>
  <Gallery
    :images="[
      require('@/assets/img/automotive/IMG_1889-1200w.jpg'),
      require('@/assets/img/automotive/IMG_2035-1200w.jpg'),
      require('@/assets/img/automotive/IMG_9480-1200w.jpg'),
      require('@/assets/img/automotive/IMG_2221-1200w.jpg'),
      require('@/assets/img/automotive/IMG_2051-1200w.jpg'),
    ]"
  />
</template>

<script>
import Gallery from '@/components/Gallery.vue'

export default {
  name: 'Automotive',
  components: {
    Gallery
  }
}
</script>
